import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import BEM from '../../bem';
import { ReactComponent as AttachmentSvg } from '../../images/attachment.svg';
import ToolTip from '../../../widgets/messenger/components/ToolTip';

const classes = BEM.with('AttachmentButton');

class AttachmentButton extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    disabledReason: PropTypes.string,
    hasAttachments: PropTypes.bool.isRequired,
    onAttachmentButton: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
    disabledReason: '',
  };

  render() {
    const { disabled, disabledReason, hasAttachments, onAttachmentButton } = this.props;

    // aria-disabled (instead of the native disabled attribute) keeps the button in the
    // tab order and the accessibility tree, so screen readers can announce why it's off.
    const ariaLabel =
      disabled && disabledReason
        ? `Message Attachment Button — ${disabledReason}`
        : 'Message Attachment Button';

    const button = (
      <button
        aria-label={ariaLabel}
        aria-disabled={disabled}
        className={classes('attachment-button-container', { disabled })}
        onClick={disabled ? undefined : onAttachmentButton}
      >
        <AttachmentSvg
          className={classes('image', { 'has-attachment': hasAttachments, disabled })}
          fill={'#dadada'}
          aria-hidden
        />
      </button>
    );

    return (
      <div className={classes()}>
        {disabled && disabledReason ? (
          <ToolTip text={disabledReason} location="top">
            {button}
          </ToolTip>
        ) : (
          button
        )}
      </div>
    );
  }
}

export default observer(AttachmentButton);
